import React from 'react';
import styled from 'styled-components';
import { Chip } from '../Chip';
import { Tooltip } from '../Tooltip';
import { ErrorIcon } from './ErrorIcon';

const StyledErrorIcon = styled(ErrorIcon)`
  width: 1rem;
  height: 1rem;
`;

const DEFAULT_TOOLTIP = 'Calculation error';

type CalculationErrorChipProps = {
  className?: string;
  label?: string;
  tooltip?: string;
};

export function CalculationErrorChip({
  className,
  label,
  tooltip = DEFAULT_TOOLTIP,
}: CalculationErrorChipProps) {
  if (label) {
    return (
      <Chip
        className={className}
        color="danger"
        icon={<StyledErrorIcon aria-hidden />}
        label={label}
      />
    );
  }

  return (
    <Tooltip title={tooltip} placement="bottom">
      <Chip
        className={className}
        color="danger"
        icon={<StyledErrorIcon aria-hidden />}
        isLabelHidden
        label={tooltip}
      />
    </Tooltip>
  );
}
